import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getLowStockItems = get(
  'inventory.components.reports.lowStockItems'
);

export const getLowStockItemsSearchQuery = createSelector(
  getLowStockItems,
  get('searchQuery')
);
